// Store
import {setLoading} from './generalActions';
import {AppDispatch} from '../../store';
import catalogServices from '../../../api/catalogServices';

// Types
import {catalogTypes} from '../types';
import {FiltersPaginationType} from '../../../types/SharedTypes';
import {AllianceStockType} from "../../../types/AllianceStockTypes";
import {ActivateCatalogType} from '../../../types/CatalogTypes';

// Constants
import baseURL from '../../../api/baseURL';

// Components and Subcomponents
import {ERROR_MODAL, SUCCESS_MODAL} from '../../../components/subComponents/responseModals';


export const getParams = (pagination?: FiltersPaginationType) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  catalogServices.getParams()
    .then((response) => {
      dispatch({
        type: catalogTypes.GET_CATALOG_PARAMS,
        catalogParams: response.data
      });
      pagination && dispatch(getAll(pagination));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const getDetail = (supermodel: string, params?: URLSearchParams) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  catalogServices.getDetail(supermodel, params)
    .then((response) => {
      dispatch({
        type: catalogTypes.GET_PRODUCT_DETAIL,
        productDetail: response.data
      });
      dispatch(setLoading(false));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const getAll = (pagination?: FiltersPaginationType) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  catalogServices.getAll(pagination)
    .then((response) => {
      dispatch({
        type: catalogTypes.GET_CATALOG,
        catalogResponse: response.data
      });
      dispatch(setLoading(false));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const uploadCatalogToExclude = (formData: FormData) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  catalogServices.uploadCatalogToExclude(formData)
    .then((response) => {
      SUCCESS_MODAL(response.data.status);
      dispatch(getAll());
      dispatch(setLoading(false));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const upload = (formData: FormData) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  catalogServices.upload(formData)
    .then((response) => {
      SUCCESS_MODAL(response.data.status);
      dispatch(getAll());
      dispatch(setLoading(false));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
export const getCatalogTemplate = () => async (dispatch: AppDispatch) => {  
  dispatch(setLoading(true));
  catalogServices.getTemplate()
    .then((response) => {
      window.open(baseURL + response.data.excelUrl, '_blank');
      dispatch(setLoading(false));
    })
    .catch(response => {
      ERROR_MODAL(response.data.error);
      dispatch(setLoading(false));
    })
}
export const getExcludeCatalogTemplate = () => async (dispatch: AppDispatch) => {  
  dispatch(setLoading(true));
  catalogServices.getExcludeCatalogTemplate()
    .then((response) => {
      window.open(baseURL + response.data.excelUrl, '_blank');
      dispatch(setLoading(false));
    })
    .catch(response => {
      ERROR_MODAL(response.data.error);
      dispatch(setLoading(false));
    })
}
export const update = (stock: AllianceStockType, supermodel: string, params?: URLSearchParams) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  catalogServices.update(stock)
    .then(() => {
      dispatch(getDetail(supermodel, params));
      dispatch(setLoading(false));
    })
    .catch(response => {
      ERROR_MODAL(response.data.error);
      dispatch(setLoading(false));
    })
}
export const activateCatalog = (data: ActivateCatalogType,  source: string, pagination?: FiltersPaginationType, params?: URLSearchParams) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  catalogServices.activateCatalog(data)
    .then(() => {
      if (source === 'list') {
        dispatch(getAll(pagination));
      }else if (source === 'detail') {
        dispatch(getDetail(data.supermodel, params));
        dispatch(setLoading(false));
      }
    })
    .catch(response => {
      ERROR_MODAL(response.data.error);
      dispatch(setLoading(false));
    })
}
